import { NetworkService } from './network-service';

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

export default class TicketService {

    static getTickets = (callback, errCallback, queryParams) => {
        NetworkService.get(`${API_BASE_URL}/ticket`, callback, errCallback, queryParams);
    };

    static getTicketsSupplier = (userId, callback, errCallback, queryParams) => {
        NetworkService.get(`${API_BASE_URL}/ticket/user/${userId}`, callback, errCallback, queryParams);
    };

    static getTicketById = (ticketId, callback, errCallback, queryParams) => {
        NetworkService.get(`${API_BASE_URL}/ticket/${ticketId}`, callback, errCallback, queryParams);
    };

    static createTicket = (companyId, body, callback, errCallback, queryParams) => {
        NetworkService.postMultiPart(`${API_BASE_URL}/ticket/company/${companyId}`, body, callback, errCallback, queryParams);
    };

    static updateTicketStatus = (ticketId, callback, errCallback, queryParams) => {
        NetworkService.put(`${API_BASE_URL}/ticket/${ticketId}/status`, {}, callback, errCallback, queryParams);
    };
}
